import { useEffect, useState } from "react";

/** Возвращает значение с задержкой `ms` мс после последнего изменения — для
 *  живого поиска (ввод → дебаунс → запрос). */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
